import { v4 as uuid } from 'uuid';

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: uuid(),
    categoryName: 'All',
  },
  {
    _id: uuid(),
    categoryName: 'Sound design',
  },
  {
    _id: uuid(),
    categoryName: 'Cinematography',
  },
  {
    _id: uuid(),
    categoryName: 'Transition',
  },
  {
    _id: uuid(),
    categoryName: 'Editing',
  },
  {
    _id: uuid(),
    categoryName: 'Photography',
  },
  {
    _id: uuid(),
    categoryName: 'Drones',
  },
  {
    _id: uuid(),
    categoryName: 'Cinematic',
  },
  {
    _id: uuid(),
    categoryName: 'Lighting',
  },
  {
    _id: uuid(),
    categoryName: 'Final cut pro',
  },
  {
    _id: uuid(),
    categoryName: 'Colors',
  },
  {
    _id: uuid(),
    categoryName: 'Lenses',
  },
  {
    _id: uuid(),
    categoryName: 'Edit Breakdown',
  },
];
